import { FullContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { CommandFilters } from '../commands/CommandFilters';
import { CommandList } from '../commands/CommandList';

export function CommandsPage() {
  const { css, theme } = useStyles();
  const [filterAsset, setFilterAsset] = useState('');
  const [filterCommandType, setFilterCommandType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [reloadPage, setReloadPage] = useState(false);

  return (
    <FullContainer
      verticalFlex
      classNames={`${css({
        padding: theme.sizing.scale400,
        gap: theme.sizing.scale500,
        boxSizing: 'border-box',
      })}`}
    >
      <CommandFilters
        selectedAsset={filterAsset}
        onChangeAsset={setFilterAsset}
        selectedCommandType={filterCommandType}
        onChangeCommandType={setFilterCommandType}
        selectedStatus={filterStatus}
        onChangeStatus={setFilterStatus}
        onReloadPage={() => setReloadPage(!reloadPage)}
      />
      <CommandList
        commandType={filterCommandType}
        status={filterStatus}
        assetId={filterAsset}
        reloadPage={reloadPage}
      />
    </FullContainer>
  );
}
